//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex';
import AuthContainer from '~/components/Auth/AuthContainer.vue';
import GoogleReCaptcha from '~/components/ReusableComponents/GoogleReCaptcha.vue';
import { AUTH_FLOW, AUTH_STEP } from '~/constants/authFlows.js';
import { APTITUDE_EXAM_TYPE_OPTIONS } from '~/constants/onboardingFields';
import { ROUTES } from '~/constants/pageRoutes';
import { PLANS } from '~/constants/premiumPlans';
import { ANALYTIC_SOURCE_MODULES } from '~/services/analyticEvents';
import { PREMIUM_PLANS } from '~/static/constants';
import { crossWhite, crossBold } from '~/static/icons';

const CDN = process.env.CDN_ENDPOINT + '/testprep/static/images';
export default {
    name: 'AuthModal',
    components: { GoogleReCaptcha, AuthContainer },
    props: {
        isAcquisitionAuth: {
            type: Boolean,
            default: false
        },
        acquisitionAuthHeading: {
            type: String,
            default: 'Read all you need! No interruptions!'
        },
        acquisitionAuthSubheading: {
            type: String,
            default: 'Just sign up once!'
        },
        webStepZeroSignupHeading: {
            type: String,
            default: 'Sign up to access your test report!'
        },
        webStepZeroSignupSubHeading: {
            type: String,
            default: 'Get insights into your strengths and weakness to prep better.'
        },
        webStepZeroLoginHeading: {
            type: String,
            default: 'We’re glad you’re back!'
        },
        webStepZeroLoginSubHeading: {
            type: String,
            default: 'Login and continue working on getting the scores you want!'
        },
        webStepOneHeading: {
            type: String,
            default: 'Hello there! Let’s get introduced'
        },
        webStepOneSubHeading: {
            type: String,
            default: ''
        },
        leftPartHeading: {
            type: String,
            default: 'Get ahead of the prep game!'
        },
        leftPartDescription: {
            type: String,
            default:
                'Enjoy a smart and smooth test-taking experience loaded with great features that will refine your performance.'
        },
        illustrationImg: {
            type: String,
            default: `${CDN}/authModalTestCard.webp`
        },
        closable: {
            type: Boolean,
            default: false
        },
        signupType: {
            type: String,
            default: '',
            required: true
        },
        isDiagnosticTestAuth: {
            type: Boolean,
            default: false
        }
    },
    data: () => {
        return {
            CDN,
            crossWhite,
            AUTH_FLOW
        };
    },
    computed: {
        ...mapState('auth', {
            onboardingStep: 'onboardingStep',
            loginMethod: 'loginMethod',
            userCountry: 'userCountry',
            isSignupHookModal: 'isSignupHookModal',
            signupHookPayload: 'signupHookPayload',
            authFlow: 'authFlow',
            profileCompletionLevel: 'profileCompletionLevel'
        }),
        ...mapGetters({
            selectedPlan: 'premium/selectedPlan',
            isAuthenticated: 'auth/isAuthenticated',
            isPremiumUser: 'auth/isPremiumUser'
        }),
        crossIcon() {
            return this.isSignupHookModal || this.isInPaymentPage ? crossWhite : crossBold;
        },
        isUserDetailsStep() {
            return [AUTH_STEP.EXAM_DETAILS, AUTH_STEP.USER_AND_EXAM_DETAILS].includes(
                this.onboardingStep?.stepName
            );
        },
        blurredModalBg() {
            return this.isBasicUserDetailsNotFilledIn && this.isUserDetailsStep
                ? `${CDN}/blurredDashboardBG.webp`
                : '';
        },
        isBasicUserDetailsNotFilledIn() {
            return (
                this.isAuthenticated &&
                this.profileCompletionLevel === 0 &&
                !this.isInPaymentPage &&
                this.authFlow === AUTH_FLOW.INDIAN_PHONE
            );
        },
        featureIllustration() {
            if (this.isSignupHookModal && this.signupHookPayload) {
                if (this.signupHookPayload.source === ANALYTIC_SOURCE_MODULES.DOWNLOADABLE_RESOURCE)
                    return `${CDN}/updatedSignupHooksIllustrationPWA.webp`;

                if (this.signupHookPayload.source === ANALYTIC_SOURCE_MODULES.MOCK_TEST_PAGE)
                    return `${CDN}/signupHooksMockTestIllustrationPWA.webp`;
            }

            if (this.isDiagnosticTestAuth) {
                return `${CDN}/authModalGreQDTestPWA.webp`;
            }
            if (this.isAcquisitionAuthStepZero) {
                return `${CDN}/blogsAuthIllustration.webp`;
            }
            if (this.isPracticePlanSelected) {
                return `${CDN}/practicePlanAuthIllustrationPWA.webp`;
            }
            if (this.isOnDemandPlanSelected) return `${CDN}/onDemandPlanAuthIllustrationPWA.webp`;
            if (this.isLiveClassesPlanSelected)
                return `${CDN}/liveClassesPlanAuthIllustrationPWA.webp`;

            return '';
        },
        isInPaymentPage() {
            return !!this.$route.params.planSlug;
        },
        isPracticePlanSelected() {
            return [PREMIUM_PLANS.PREP_PLUS_1_MONTH, PREMIUM_PLANS.PREP_PLUS_3_MONTH].includes(
                this.selectedPlan?.slug
            );
        },
        isOnDemandPlanSelected() {
            return this.selectedPlan?.slug === PREMIUM_PLANS.PREP_PLUS_ONDEMAND;
        },
        isLiveClassesPlanSelected() {
            return this.selectedPlan?.slug === PREMIUM_PLANS.PREP_PLUS_LIVECLASS;
        },
        isAuthStepZero() {
            return [AUTH_STEP.PHONE_INPUT, AUTH_STEP.EMAIL_INPUT, AUTH_STEP.GOOGLE_SIGNIN].includes(
                this.onboardingStep.stepName
            );
        },
        isAcquisitionAuthStepZero() {
            return this.isAcquisitionAuth && this.isAuthStepZero;
        },
        authContainerHeight() {
            if (
                !this.isSignupHookModal &&
                !this.isInPaymentPage &&
                (this.isAcquisitionAuthStepZero || this.isDiagnosticTestAuth)
            ) {
                if (this.userCountry === 'IN') {
                    return this.$device.isMobile
                        ? 'min-h-[391px] h-full'
                        : 'min-h-[370px] lg:min-h-[344px] h-full';
                } else {
                    return this.$device.isMobile
                        ? 'min-h-[391px] h-full'
                        : 'min-h-[407px] lg:min-h-[375px] h-full';
                }
            }

            return 'h-full';
        },
        isNonDismissableModal() {
            if (process.client) {
                return Boolean(window.sessionStorage.getItem('acq_auth_shown'));
            }

            return false;
        },
        isInAllIndiaGreLiveTestPage() {
            return this.$route.path === ROUTES.ALL_INDIA_GRE_LIVE_TEST;
        }
    },
    mounted() {
        if (
            this.isInAllIndiaGreLiveTestPage ||
            this.signupType === PLANS.PREP_PLUS ||
            this.isPremiumUser
        ) {
            this.$store.commit('auth/setCandidateAptitudeExamType', APTITUDE_EXAM_TYPE_OPTIONS[0]);
        }
    },
    methods: {
        closeModal() {
            if (!this.isInPaymentPage && !this.isBasicUserDetailsNotFilledIn) {
                this.$store.commit('auth/setContinueRoute', '');
                this.$store.commit('auth/resetOnboardingDetails');
                this.$emit('closeModal');
            }
        }
    }
};
